import styled from 'styled-components';
import { ToggleButton } from './ToggleButton';

type ToggleButtonsProps = {
  flow?: 'horizontal' | 'vertical'
}

export const ToggleButtons = styled.div<ToggleButtonsProps>`
  display: flex;
  flex-direction: ${props => props.flow !== 'horizontal' ? 'column' : 'row'};
  margin-top: 5px;

  ${ToggleButton} {
    &:first-of-type {
      border-radius: ${props => props.flow !== 'horizontal' ? '6px 6px 0 0' : '6px 0 0 6px'};
      margin: ${props => props.flow !== 'horizontal' ? '0 0 -1px 0' : '0 -1px 0 0'};
    }

    &:last-of-type {
      border-radius: ${props => props.flow !== 'horizontal' ? '0 0 6px 6px' : '0 6px 6px 0'};
    }
  }
`;
